import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const StyledLogo = styled.img`
  cursor: pointer;
  width: ${(props) => props.wid || '288px'};

  @media (max-width: 1024px) {
    width: ${(props) => props.wid || '180px'};
  }
`;

const Logo = (props) => {
  const navigate = useNavigate();
  const logoUri = props.white
    ? require(`assets/branding/logo-white.png`)
    : require(`assets/branding/logo-black.png`);

  return <StyledLogo wid={props.wid} src={logoUri} onClick={() => navigate('/')} />;
};

export default Logo;
